import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["socSupportCallback", "socSupportChat", "socSupportEmail"]

  connect() {
    if (this.data.get("showCallbackRequest") === "true") {
      this.element.querySelector(".request-callback-option")?.click()
    }
  }

  open(evt) {
    zE.activate()
    evt.preventDefault()
  }

  get isSocSupportChatOffline() {
    return $zopim.livechat.departments.getDepartment("SOC Support")?.status !== "online"
  }

  socSupportChatTargetConnected() {
    this.updateSocSupportChatAvailability()
  }

  async socSupportChatTargetDisconnected(element) {
    $(element).tooltip("destroy")
  }

  socSupportButtonClicked(evt) {
    this.updateSocSupportChatAvailability()

    if (!this.element.classList.contains("open")) {
      this.sendStateToAmplitude(evt.currentTarget.dataset.href)
    }
  }

  updateSocSupportChatAvailability() {
    const isSocSupportChatOffline = this.isSocSupportChatOffline

    this.socSupportChatTarget.classList.toggle("disabled", isSocSupportChatOffline)
    $(this.socSupportChatTarget).tooltip(isSocSupportChatOffline ? "enable" : "disable")
  }

  liveChat(evt) {
    if (this.isSocSupportChatOffline) {
      this.updateSocSupportChatAvailability()
      evt.stopPropagation()
      return
    }

    zE("webWidget", "updateSettings", {
      webWidget: {
        chat: {
          departments: {
            select: "SOC Support"
          },
          suppress: false
        },
        answerBot: { suppress: true },
        contactForm: { suppress: true },
        helpCenter: { suppress: true },
        talk: { suppress: true }
      }
    })

    zE("webWidget", "chat:addTags", ["request_SOC_support_chat"])

    zE("webWidget", "open")
  }

  sendStateToAmplitude(url) {
    let details = {
      email_conversation_enabled: !this.socSupportEmailTarget.classList.contains("disabled"),
      email_conversation_title: this.socSupportEmailTarget.dataset.title || "",
      live_chat_enabled: !this.socSupportChatTarget.classList.contains("disabled"),
      live_chat_title: this.socSupportChatTarget.dataset.title || "",
      callback_request_enabled: !this.socSupportCallbackTarget.classList.contains("disabled"),
      callback_request_title: this.socSupportCallbackTarget.dataset.title || ""
    }

    $.ajax({
      url: url,
      method: "POST",
      data: JSON.stringify(details),
      dataType: "json",
      contentType: "application/json",
    })
  }
}
